<href class="w-12 image-component"
      [ngClass]="[component.ratio || '']"
      [link]="component.cta_link">
    <img class="rf"
         [image]="component.image">
</href>